/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation200,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation500,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationQueryResponse,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation.ts";
import { gradeSimulationViewModelSchema } from "../gradeSimulationViewModelSchema.ts";

export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation200Schema =
  z.lazy(
    () => gradeSimulationViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation500>;

export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulation200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationQueryResponse>;
